import { Scope } from './scope';

export class Scopes {
    count: number;
    totalCount: number;
    items: Scope[];
    token: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/entities/scopes.ts